import { render, staticRenderFns } from "./nestedWithUL.vue?vue&type=template&id=3e570fbe&scoped=true"
import script from "./nestedWithUL.vue?vue&type=script&lang=js"
export * from "./nestedWithUL.vue?vue&type=script&lang=js"
import style0 from "./nestedWithUL.vue?vue&type=style&index=0&id=3e570fbe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e570fbe",
  null
  
)

export default component.exports